import { render } from "./NoEvents.vue?vue&type=template&id=fd01693a&scoped=true"
import script from "./NoEvents.vue?vue&type=script&lang=js"
export * from "./NoEvents.vue?vue&type=script&lang=js"

import "./NoEvents.vue?vue&type=style&index=0&id=fd01693a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd01693a"]])

export default __exports__